module.exports = __webpack_public_path__ + "bd4cdcd3d11b9fae926b26b862b252f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/features_camera.png
// module id = HLVw
// module chunks = 5